define('taoQtiItem/qtiCreator/widgets/choices/states/Sleep',['taoQtiItem/qtiCreator/widgets/states/factory', 'taoQtiItem/qtiCreator/widgets/states/Sleep'], function(stateFactory, Sleep){
    
    var ChoiceStateSleep = stateFactory.create(Sleep, function(){
        
    }, function(){
        
    });
    
    return ChoiceStateSleep;
});
